/**
 * Helpers de presentación del dominio de Notificaciones.
 *
 * Puro formato/derivación para la UI; sin lógica de negocio ni acceso a la API
 * (`docs/frontend_architecture.md`, Pr. 6).
 */
import {
  DEFAULT_EVENT_STYLE,
  EVENT_STYLES,
  type EventStyle,
} from "./constants";

/** Estilo (chip/label) de un evento; cae al estilo por defecto si no está en el mapa. */
export function eventStyle(evento: string): EventStyle {
  return EVENT_STYLES[evento] ?? DEFAULT_EVENT_STYLE;
}

/**
 * Texto del badge de la campana a partir del conteo: vacío si no hay novedades,
 * el número si es < 10, o "9+" si lo supera (réplica del SSR: `count < 10 ? count
 * : '9+'`). Se devuelve string para pintarlo directamente.
 */
export function badgeText(count: number): string {
  if (count <= 0) {
    return "";
  }
  return count < 10 ? String(count) : "9+";
}
